export const images = {
  hero: "https://images.pexels.com/photos/20130631/pexels-photo-20130631.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  curtains:
    "https://images.unsplash.com/photo-1688489307301-f6e3b15e01bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODl8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwY3VydGFpbnMlMjBkcmFwZXMlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODMyODIwOTl8MA&ixlib=rb-4.1.0&q=85",
  flooring:
    "https://images.unsplash.com/photo-1649083048770-82e8ffd80431?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBoYXJkd29vZCUyMGZsb29yaW5nJTIwaW50ZXJpb3J8ZW58MHx8fHwxNzg1MjIwNzk0fDA&ixlib=rb-4.1.0&q=85",
  wallpaper:
    "https://images.unsplash.com/photo-1661205734852-966d2d1d951d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwzfHxiZWF1dGlmdWwlMjBpbnRlcmlvciUyMHdhbGxwYXBlciUyMGFlc3RoZXRpY3xlbnwwfHx8fDE3ODM0Mzc4Mzh8MA&ixlib=rb-4.1.0&q=85",
  painting:
    "https://images.pexels.com/photos/5583126/pexels-photo-5583126.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const contact = {
  phone: "+3226721436",
  phoneDisplay: "02 672 14 36",
  url: "https://decoligot.be/contact/",
  address: "Chaussée de Wavre 1314, 1160 Bruxelles",
  mapsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=" +
    encodeURIComponent("Déco Ligot, Chaussée de Wavre 1314, 1160 Bruxelles"),
};

export const PRO_LEGAL_LINE =
  "Outil de calcul fourni par Déco Ligot via QuoteDesign. Tout devis reste sous la responsabilité exclusive du professionnel mandaté.";

export const categories = [
  { key: "curtains", image: images.curtains, icon: "Wind" },
  { key: "flooring", image: images.flooring, icon: "Grid3x3" },
  { key: "wallpaper", image: images.wallpaper, icon: "Layers" },
  { key: "painting", image: images.painting, icon: "PenLine" },
];
